import React from "react";
import styled from "styled-components";
import { breakpoints } from '../../styled-components/constants';

const DayWrapper = styled.div`
  background: #3B3E4D;
  display: ${props => props.hideNavMobile && props.isNav ? 'none' : 'inline-block'};
  padding: 5px;
  margin: 0 4px;
  border-radius: 4px;
  text-align:right;
  h2 {
    font-size: ${props => props.isNav ? '18px' : '32px'};
    background: #FF6F43;
    color: white;
    font-weight: 300;
    padding: 0;
    width: ${props => props.isNav ? '35px' : '50px'};
    height: ${props => props.isNav ? '35px' : '50px'};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }
  p {
    font-size: ${props => props.isNav ? '10px' : '12px'};
    color: white;
    padding: 7px 0 0 0;
    text-align: center;
  }
  @media (min-width: ${breakpoints.desktop}) {
    display: inline-block;
  }
`;

const DayCounter = ({time, label, isNav, hideNavMobile}) => (
  <DayWrapper isNav={isNav} hideNavMobile={hideNavMobile}>
    <h2>{time}</h2>
    <p>{label}</p>
  </DayWrapper>
)

export default DayCounter;



// WEBPACK FOOTER //
// ./src/components/CountdownElement/DayCounter.js